export default "__VITE_ASSET__CxoLBcQJ__"